module.exports = __webpack_public_path__ + "static/media/3_17.47997e79.png";